angular.module('core')
    .component('fullCalendar', {
        bindings: {
            options: '<',
            onInit: '&',
            fillViewport: '<?'
        },
        controller: function ($element, $scope, ManufacturingOrderService) {
            this.$onInit = () => {
                let calendarEl = $element[0];
                this.calendar = this.initCalendar(calendarEl, this.options);
                if (angular.isFunction(this.onInit()))
                    this.onInit()(this.calendar);
            }

            this.initCalendar = (element, options) => {
                let isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent));
                let height = isMobile ? "auto" : 800;
                let defaultConfig = {
                    plugins: ['dayGrid', 'timeGrid', 'list', 'interaction'],
                    header: {left: 'today, prev,next', center: 'title', right: 'dayGridMonth,timeGridWeek,dayGridWeek,listDay'},
                    defaultView: "timeGridWeek",
                    locale: 'pl',
                    weekNumbers: true,
                    businessHours: {
                        dow: [1, 2, 3, 4, 5],
                        start: '8:00',
                        end: '17:00',
                    },
                    height: height,
                    eventSources: this.eventSources
                };
                angular.extend(defaultConfig, options);
                if (this.fillViewport === true && !isMobile) {
                    defaultConfig.height = () => Math.max(400, window.innerHeight - element.getBoundingClientRect().top - 10);
                }
                let calendar = new FullCalendar.Calendar(element, defaultConfig);
                calendar.render();
                return calendar;
            }
        }
    })
